const SUCCESS_CUSTOMER_LOGO = "SUCCESS_CUSTOMER_LOGO";
const LOADING_CUSTOMER_LOGO = "LOADING_CUSTOMER_LOGO";
const SAVED_SELECTED_CUSTOMER_LOGO = "SAVED_SELECTED_CUSTOMER_LOGO";

export const CobrandLogoTypes = {
  SUCCESS_CUSTOMER_LOGO,
  LOADING_CUSTOMER_LOGO,
  SAVED_SELECTED_CUSTOMER_LOGO
};
